
function DropDownItem(props) {

    const dropDownItems = props.elements;
    const fontStyle = props.fontStyle || 'font-light';
    const fontColor = props.fontColor || 'text-gray-500 dark:text-gray-400';
    const fontSize = props.fontSize || 'text-sm'
    const handleTrigger = async (e) => {
        e.preventDefault();
        console.log(e.target.value);
        props.onTrigger(e);
    }

    return (
        <div>
            <ul className={` py-1 ${fontStyle} ${fontColor} ${fontSize}`}>
                {dropDownItems?.elements.map((elem) => (
                    <li key={elem.id}>
                        <button
                            value={[elem.id, elem.value]}
                            onClick={handleTrigger}
                            className={`${elem.logo ? 'flex justify-center ' : 'block'} w-full py-2 px-4 hover:bg-gray-100 dark:hover:bg-gray-600 dark:text-gray-400 dark:hover:text-white transition-all ease-in-out`} >
                            {elem.logo ? <svg className="mr-2 w-5 h-5 text-gray-400" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d={elem.logo}></path></svg> : ''}
                            {elem.name}
                        </button>
                    </li>
                ))}
            </ul>
        </div>
    );
}

export default DropDownItem;